import React, {Component, PropTypes} from 'react';

import BasicLayout from 'layouts/Basic';

import RecruitersDataGrid from 'components/recruiters/DataGrid.jsx';
import RecruitersIndepth from 'components/recruiters/Indepth.jsx';
import RecruitersControls from 'components/recruiters/Controls.jsx';

const Page = props => {
  return (
    <BasicLayout
      hero={props.selected && <RecruitersIndepth {...props} />}
      main={<RecruitersDataGrid {...props} />}
      aside={<RecruitersControls {...props} />}
    />
  );
};

import {resource} from 'utils/resourcerizer';

import {RECRUITERS_NS} from 'constants/index';

Page.Container = resource(RECRUITERS_NS)(Page);

export default Page;



// WEBPACK FOOTER //
// ./src/components/recruiters/Page.jsx